import { AspectRatio, Box, Container, Image } from "@chakra-ui/react";

const Poster = () => {
  return (
    <Box w="100%" mt={10} boxShadow="md">
      <Image
        src="https://d2407na1z3fc0t.cloudfront.net/Slider/banner_63630e9d6ba0e"
        alt="Poster"
      />
    </Box>
  );
};

export default Poster;
